import React, { Fragment, useRef, useState } from "react";
import "./ReportCreationSheet.scss";
import { useDraggableSheet } from "../../../helpers/hooks";
import Icon from "../Icon/Icon"; // Optional, if you use an icon like a back arrow
import { fetchReportCreation, updateReportOnCreation } from "../../Reducers/actions/creationsActions";
import useAutoGrowTextarea from '../../hooks/useAutoGrowTextarea';
import { fetchReportNews, updateReportOnNews } from "../../Reducers/actions/newsActions";
import { useDispatch } from "react-redux";
import { fetchReportUser, updateReportOnUser } from "../../Reducers/actions/userActions";

const reasons = [
    "Inappropriate content",
    "Illegal content",
    "Racism and hate speech content",
    "Spam",
    "Scam",
    "Other (I have my own reason)",
];

const ReportCreationSheet = ({ onClose, creation_id, type = 'creation' }) => {
    const [is_other, setIsOther] = useState(false)
    const [text, setText] = useState("")
    const [reportSuccess, setReportSuccess] = useState(false)
    const dispatch = useDispatch()
    const textareaRef = useRef(null);
    const {
        sheetStyle,
        overlayHandlers
    } = useDraggableSheet({ onClose });

    useAutoGrowTextarea(textareaRef, text);

    const handleReasonSelect = (reason) => {
        if (reason === "Other (I have my own reason)") {
            setIsOther(true)
        } else {
            if (type === 'creation') {
                fetchReportCreation(creation_id, reason).then(({ success }) => {
                    if (success) {
                        setReportSuccess(true)
                        dispatch(updateReportOnCreation(creation_id))
                    }
                })
            } else if (type === 'news') {
                fetchReportNews(creation_id, reason).then(({ success }) => {
                    if (success) {
                        setReportSuccess(true)
                        dispatch(updateReportOnNews(creation_id))
                    }
                })
            } else {
                fetchReportUser(creation_id, reason).then(({ success }) => {
                    if (success) {
                        setReportSuccess(true)
                        dispatch(updateReportOnUser(creation_id))
                    }
                })
            }
        }
    }

    const handleSubmit = () => {
        if (type === 'creation') {
            fetchReportCreation(creation_id, text).then(({ success }) => {
                if (success) {
                    setIsOther(false)
                    setReportSuccess(true)
                    dispatch(updateReportOnCreation(creation_id))
                }
            })
        } else if (type === 'news') {
            fetchReportNews(creation_id, text).then(({ success }) => {
                if (success) {
                    setIsOther(false)
                    setReportSuccess(true)
                    dispatch(updateReportOnNews(creation_id))
                }
            })
        } else {
            fetchReportUser(creation_id, text).then(({ success }) => {
                if (success) {
                    setIsOther(false)
                    setReportSuccess(true)
                    dispatch(updateReportOnUser(creation_id))
                }
            })
        }
    }

    return (
        <Fragment>
            <div className="report-sheet-overlay" onClick={onClose} {...overlayHandlers}>
                <div
                    className={`report-sheet ${is_other ? 'expanded' : ''}`}
                    style={sheetStyle}
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="pull-bar" />
                    {!reportSuccess ? <Fragment>
                        <h4 className="title fg-crea fs-sm2 fw-medium-bold mb-40">
                            Why are you reporting this {type === 'creation' ? "creation" : type === 'news' ? "news" : "user"}?
                        </h4>

                        <div className="report-options">
                            {!is_other ? reasons.map((reason, idx) => (
                                <div
                                    key={idx}
                                    className="report-option"
                                    onClick={() => handleReasonSelect(reason)}
                                >
                                    <span className="fs-regular">{reason}</span>
                                    <Icon alias="chevron-right" className={"ml-auto"} width={20} color="#999" />
                                </div>
                            )) :
                                <Fragment>
                                    <div>
                                        <div
                                            className="report-option"
                                            onClick={() => setIsOther(false)}
                                        >
                                            <Icon alias="chevron-left" className={"mr-16"} width={20} color="#777" />
                                            <span className="fs-regular">{reasons[5]}</span>
                                        </div>
                                    </div>
                                    <textarea
                                        ref={textareaRef}
                                        value={text}
                                        onChange={(e) => setText(e.target.value)}
                                        placeholder="Describe why this creation bothers you"
                                        className="report-textarea"
                                        rows={1}
                                        style={{ height: '48px' }}
                                    />
                                </Fragment>
                            }
                        </div>
                        {is_other && <button className={`btn submit-btn  red-btn aic jcc fw-bold mb-16`} onClick={handleSubmit} disabled={text?.length === 0}>
                            Submit
                        </button>}
                    </Fragment> : <div className="d-flex aic jcc f-column my-40 pb-40">
                        <Icon alias={'report-success'} width={80} />
                        <p className="fg-crea fs-sm2 fw-medium-bold mt-24 mb-12">Thanks for letting us know</p>
                        <p className="fg-hyk-medgrey fs-regular ta-center">We've received your report and will review this {type === 'creation' ? "creation" : type === 'news' ? "news" : "user"} to make sure HYK stays a safe and inspiring space for everyone.</p>
                        <div className="done-container">
                            <button className={`done-btn btn red-outline-btn aic jcc fw-bold mb-16`} onClick={onClose}>
                                Done
                            </button>
                        </div>
                    </div>}
                </div>


            </div>
        </Fragment>
    );
};

export default ReportCreationSheet;
